import Keycloak from "keycloak-js";

export const initOptions: any = {
    url: process.env.REACT_APP_KEY_CLOAK_URL,
    realm: process.env.REACT_APP_KEY_CLOAK_REALM,
    clientId: process.env.REACT_APP_KEY_CLOAK_CLIENT_ID,
    onLoad: 'login-required'
}

export const keycloak: any = Keycloak(initOptions);